/**
 * Has the support-ticket flow finished this turn?
 *
 * Read the STRUCTURED signal the backend already sends, not the assistant's
 * prose. `raw_output_keys.py` whitelists `ticket_id` and `show_upload` for
 * report_issue, and documents show_upload as "tells the web frontend to reveal
 * (True) or hide (False) the photo-upload icon".
 *
 * Prose matching used to work only because the templates literally said
 * "Your ticket has been submitted ... Reference number:". Backend commit
 * b453dbcf reworded them and added free-form AI replies, so the match stopped
 * firing: the uploader stayed open, the thumbnail was never cleared, and the
 * stale image was re-sent with the next message. The legacy phrases are kept
 * below purely as a safety net for any older deployment.
 */

const TICKET_INTENT = 'report_issue';

// Wording used before b453dbcf. Retained for backwards compatibility only —
// do not add to this list; use the structured signals instead.
const LEGACY_SUCCESS_PHRASES = [
  'Your ticket has been submitted',
  'ticket has been submitted',
  'Reference number:',
];

/**
 * @param {object|null} response  v1 chat response
 * @param {string} messageContent assistant text (legacy fallback only)
 * @returns {boolean} true when the uploader should close and attachments clear
 */
export const isTicketFlowEnded = (response, messageContent = '') => {
  if (!response) return false;

  const rawOutput = response.raw_output || {};
  const isTicketTurn =
    response.intent === TICKET_INTENT || rawOutput.type === TICKET_INTENT;
  if (!isTicketTurn) return false;

  // Ticket created — the id only ever appears on success.
  if (rawOutput.ticket_id !== undefined && rawOutput.ticket_id !== null) return true;

  // Explicit "hide the uploader": submit, AI cancel, and intent switch all set
  // this. Strict false — the static path omits the key entirely, and `undefined`
  // must not be read as "close".
  if (rawOutput.show_upload === false) return true;

  return LEGACY_SUCCESS_PHRASES.some((phrase) => (messageContent || '').includes(phrase));
};

export default isTicketFlowEnded;
